import { CommonUtilities }  from '../../commonUtils';

export default class AssetLinkingServices  {
    
    
    //https://qa.onkorrect.com/Api/catalogue/projectAsset/list?projectId=62&type=contract&pageNumber=1&pageSize=10&
    static projectAssetList(data : any) {
        var url = 'catalogue/projectAsset/list?'+data;
       return CommonUtilities.getData(url);
    }

    static projectAssetListMyAsset(data : any) {
        var url = 'catalogue/projectAsset/listMyAsset?' + data;
        
       return CommonUtilities.getData(url);
    }

    //https://staging.onkorrect.com/Api/catalogue/projectAsset/save
    static projectAssetSave(data : any) {
        var url = 'catalogue/projectAsset/save';
        console.log(data)
        // return null;
       return CommonUtilities.postData(url, data);
    }
    //https://staging.onkorrect.com/Api/catalogue/projectAsset/linkProjectContractByContact?projectId=60453&kontactCode=SBMG&assetType=contract
    static linkProjectContractByContact ( data:any) {
        
        var url = 'catalogue/projectAsset/linkProjectContractByContact?projectId=60453&kontactCode=SBMG&assetType=contract';
        var url1 ="" ;
        return CommonUtilities.getData(url1);
    }

    //https://staging.onkorrect.com/Api/catalogue/projectAsset/delete/107717
    static unlinkAsset (data:any) {        
        var url = 'catalogue/projectAsset/delete/'+data;
        console.log(url)
        return CommonUtilities.deleteData(url);      
    }

    //https://staging.onkorrect.com/Api/catalogue/projectAsset/unlinkProjectByContact?projectId=60453&kontactCode=AA03974441&assetType=contract
    static unlinkContact (data:any) {         
        var url = 'catalogue/projectAsset/unlinkProjectByContact?' + data;
        console.log(url)
       return CommonUtilities.deleteData(url);       
    }

    //https://staging.onkorrect.com/Api/catalogue/projectAsset/addTracksToProject?projectId=50434&catlognumber=0000000052313
    static addTracksToProject (data:any) {         
        var url = 'catalogue/projectAsset/addTracksToProject?' + data;
        
        return CommonUtilities.getData(url);       
    }
    
    //https://qa.onkorrect.com/Api/catalogue/projectAsset/saveProjectAssets
    static saveProjectAssets (data:any) {         
        var url = 'catalogue/projectAsset/saveProjectAssets';
        
        return CommonUtilities.postData(url, data);     
    }
}